import * as types from './actionTypes.mobileSpecificBehaviour';
import initialState from '../initialState';

let initialStateObj = {
    isMobileWarningShown: initialState.isMobileWarningShown,
};

export default function MobileSpecificBehaviourReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.SHOW_MOBILE_WARNING_OK:
            return {
                ...state,
                ...{
                    isMobileWarningShown: true,
                }
            };

        case types.HIDE_MOBILE_WARNING_OK:
            return {
                ...state,
                ...{
                    isMobileWarningShown: false,
                }
            };

        default:
            return state;
    }
}